import {
  Fragment,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { fetchCategories, setSelectedCategory } from "../../../redux/category";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import SearchInput from "../../UI/SearchInput/SearchInput";
import Loader from "../../UI/Loader/Loader";
import { AuthContext } from "../../../context/authContext";
import { useTranslation } from "react-i18next";
import classes from "./Categories.module.scss";

const Categories = () => {
  const { t } = useTranslation();
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const { token } = useContext(AuthContext);
  const { categories, isLoading, error } = useSelector(
    (state) => state.category
  );
  const [filterText, setFilterText] = useState("");

  useEffect(() => {
    if (token) {
      dispatch(fetchCategories(token));
    }
  }, [dispatch, token]);

  const goToDishes = (id) => {
    dispatch(setSelectedCategory(id));
    navigate("/orders/categories/dishes");
  };

  const getFilteredCategories = useCallback(() => {
    if (!categories) {
      return [];
    }
    if (filterText === "") {
      return categories;
    }
    const filteredCategories = categories.filter(
      (category) =>
        category.name
          .toLocaleLowerCase()
          .indexOf(filterText.toLocaleLowerCase()) > -1
    );
    return filteredCategories;
  }, [filterText, categories]);

  const inputChangeHandler = (e) => {
    setFilterText(e.target.value);
  };

  const filteredCategories = useMemo(
    () => getFilteredCategories(),
    [getFilteredCategories]
  );

  let allCategories = null;
  let errorMessage = null;
  let noCategoryFound = null;
  let spinner = null;

  if (!error && !isLoading && categories) {
    allCategories = filteredCategories.map((category, index) => {
      return (
        <div
          tabIndex={index + 1}
          key={category.name}
          onClick={() => goToDishes(category.id)}
          className={classes.Category}
          onKeyDown={(e) => {
            if (e.code === "Enter") {
              goToDishes(category.id);
            }
          }}
        >
          <h3>{category.name}</h3>
          <h3>{category.arabicText}</h3>
        </div>
      );
    });
  }

  // if (error) {
  //   errorMessage = <p className={classes.Error}>{error}</p>;

  // }
  if (error && !isLoading) {
    // errorMessage = <p className={classes.Error}>{error}</p>;
    errorMessage = <h3>{t("NOTF_NO_CATEGORIES")}.</h3>;
  }

  if (!error && !isLoading && categories && filteredCategories.length === 0) {
    noCategoryFound = (
      <h2 className={classes.NoCategoryFound}>{t("NOTF_NO_CATEGORY")}.</h2>
    );
  }

  if (isLoading) {
    spinner = (
      <div className={classes.LoaderContainer}>
        <Loader />
      </div>
    );
  }

  return (
    <Fragment>
      <div className={classes.CategoriesHeader}>
        <h2>{t("CATEGORIES")}</h2>
        <div className={classes.Input}>
          <SearchInput onChanged={inputChangeHandler} />
        </div>
      </div>
      {errorMessage}
      <div className={classes.Categories}>
        {!token && <h3>{t("NOTF_NO_ACCESS")}!</h3>}
        {allCategories}
        {noCategoryFound}
        {spinner}
      </div>
    </Fragment>
  );
};

export default Categories;
